export enum MapBefore {
  BACKGROUND = 'BACKGROUND',
  CONTENT = 'CONTENT',
}
